import { useEffect, useState } from 'react'
import { getLeaderboardLive } from '../../services/api'
import { useT } from '../../hooks/useTranslation'

// Счётчик «уже заработали сегодня / вчера» (п.28 task.txt + task.txt П.1).
// Ненавязчивая серая строка на Главной: «Уже заработали сегодня: $1,234 ·
// s0m***y +$45», где имя меняется по очереди каждые ~3с (из живой ленты
// виртуальной торговли лидерборда). Когда сегодня плюсовых сделок нет —
// показываем «вчера» с теми же именами из вчерашней ленты. Стиль намеренно
// приглушённый: мелкий шрифт, серый цвет, без карточки и без эффектов — это
// фон для FOMO, а не центр внимания.

// Формат денежной суммы: $360 → «$360», $1234.5 → «$1,235», $12.34 → «$12.34».
const fmtUsd = (x) => {
  const n = Number(x) || 0
  if (n >= 1000) return '$' + n.toLocaleString('en-US', { maximumFractionDigits: 0 })
  return '$' + (Number.isInteger(n) ? String(n) : n.toFixed(2))
}

// Формат суммы СО ЗНАКОМ: +$45 / -$12.34. Единственный знак — чтобы не было
// «+$-12.34» и «++$45» (п.2/6 task.txt): убыток рисуется как -$X, а не +$-X.
const fmtSigned = (x) => {
  const n = Number(x) || 0
  if (n === 0) return fmtUsd(0)
  return (n < 0 ? '-' : '+') + fmtUsd(Math.abs(n))
}

// Плавная смена имени (без внешних CSS — один keyframe в <style>).
const ROTATE_FADE = `
@keyframes scalpexEarnedIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}
`

export default function TodayEarned() {
  const t = useT()
  const [live, setLive] = useState(null)
  const [idx, setIdx] = useState(0)

  useEffect(() => {
    let alive = true
    const load = async () => {
      try {
        const data = await getLeaderboardLive()
        if (alive) setLive(data)
      } catch { /* API недоступен — строка просто не появляется */ }
    }
    load()
    const poll = setInterval(load, 60_000)
    const rot = setInterval(() => setIdx(i => i + 1), 3000)
    return () => { alive = false; clearInterval(poll); clearInterval(rot) }
  }, [])

  // П.3 task.txt: если сегодня плюсовых PNL нет (0 или вовсе нет сделок) —
  // показываем «вчера заработали», чтобы строка никогда не была нулевой.
  // Если и вчера данных нет — строку не показываем вовсе (показывать нечего).
  const todayPnl = Number(live?.today?.pnl ?? 0)
  const yesterdayPnl = Number(live?.yesterday?.pnl ?? 0)
  if (todayPnl <= 0 && yesterdayPnl <= 0) return null

  const useToday = todayPnl > 0
  const label = useToday ? t.earnedToday : t.earnedYesterday
  const amount = useToday ? todayPnl : yesterdayPnl
  const byText = useToday ? t.earnedTodayBy : t.earnedYesterdayBy

  // Живая лента имён: сегодня — по recent, вчера — по recentYesterday
  // (П.1 task.txt: «вчера заработали» тоже с именами, как «сегодня»).
  const list = useToday
    ? (Array.isArray(live.recent) ? live.recent : [])
    : (Array.isArray(live.recentYesterday) ? live.recentYesterday : [])
  const recent = list.filter(r => r && r.trader)
  const item = recent.length ? recent[idx % recent.length] : null

  return (
    <>
      <style>{ROTATE_FADE}</style>
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4,
        fontSize: 11, color: '#636366',
        padding: '6px 0 2px',
        // Не перехватываем клики — строка не интерактивна.
        pointerEvents: 'none',
      }}>
        <span>{label}</span>
        <b style={{ fontWeight: 600, color: '#8E8E93' }}>{fmtUsd(amount)}</b>
        {item ? (
          <span key={`${item.symbol}-${item.ts}`} style={{ animation: 'scalpexEarnedIn 0.5s ease' }}>
            · {byText
              .replace('{name}', item.trader)
              .replace('{x}', fmtSigned(item.pnl))}
          </span>
        ) : null}
      </div>
    </>
  )
}
